module.exports = __webpack_public_path__ + "img/memo-pad.135aa780.svg";